var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Button } from '@leapfinance/geebee-component-library';
import { Box, Divider, Popper } from '@mui/material';
import classNames from 'classnames';
var CustomFilterPoppper = function (_a) {
    var children = _a.children, onApply = _a.onApply, rest = __rest(_a, ["children", "onApply"]);
    return (React.createElement(Popper, __assign({}, rest, { className: classNames('lfc-w-[400px] lfc-mt-1 lfc-shadow-lg lfc-border lfc-rounded-md  lfc-bg-white ', rest.className), placement: "bottom-start" }),
        React.createElement(Box, { sx: {
                '& .MuiAutocomplete-paper': {
                    border: 'none'
                }
            }, className: " lfc-flex lfc-flex-col" },
            children,
            React.createElement(Divider, null),
            React.createElement("div", { className: "lfc-p-2 lfc-self-end " },
                React.createElement(Button, { onMouseDown: function (event) {
                        onApply === null || onApply === void 0 ? void 0 : onApply();
                    } }, "Apply")))));
};
export default CustomFilterPoppper;
//# sourceMappingURL=CustomMultiselectFilterPoppper.js.map